controllers.controller('AccountFrozenController', [
    '$scope', '$state', '$ionicLoading', 'LocaleService', 'API', 'constants', 'LoginService',
    function ($scope, $state, $ionicLoading, LocaleService, API, Const, LoginService) {

        LocaleService.wait().then(function (translation) {
            $scope.translation = translation;
        });

        $scope.sendTicket = function () {
            var request = {
                type: Const.ticketTypes.loginProblem,
                subject: 'Reactivate Account / No trading Account',
                description: 'Contact the customer for account reactivation or login to the trading account. '
                + 'The customer`s account has been deleted, archived or other issue that prevent successful login'
            };

            $ionicLoading.show();
            API.createTicket(request); //async action

            return LoginService.logout()
                .then(function () {
                    $ionicLoading.hide();
                    return $state.go('welcome');
                });
        };

    }]);